import { twMerge } from "tailwind-merge";

export const classesMergeMixin = {
    methods: {
        $twMerge(...classes) {
            return twMerge(...classes);
        }
    }
};
